module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Bold.394e6b1.woff2";